import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let onUnauthorizedHandler = null;
export function setOnUnauthorized(handler) { onUnauthorizedHandler = handler; }

// URLs that legitimately 401 for anonymous visitors (public pages call them
// opportunistically). These MUST NOT trigger the global redirect-to-login.
const PUBLIC_OPTIONAL_401 = [
  "/auth/me",
  "/auth/login",
  "/hrm/staff-directory",  // Departments page fetches directory for signed-in members; anonymous 401 is expected.
  "/hrm/applications/mine", // Dashboard side-fetch; runs before hard auth check.
  "/surveys/pending/mine",  // ditto
  "/hrm/postings",          // Public list — never 401, but include for defence.
];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isPublicOptional = PUBLIC_OPTIONAL_401.some(u => url.includes(u));
    if (status === 401 && onUnauthorizedHandler && !isPublicOptional) {
      onUnauthorizedHandler();
    }
    return Promise.reject(err);
  }
);

export function formatError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LABEL = {
  chief: "Chief",
  deputy_chief: "Deputy Chief",
  head_councillor: "Head Councillor",
  councillor: "Councillor",
  executive_director: "Executive Director",
  staff_member: "Staff Member",
  band_member: "Band Member",
  band_registry_clerk: "Band Registry Clerk",
};
